import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useFetchHeaderContentQuery } from "../../../../stores/api/pages.api";
import useFrontendMeta from "../../../../hooks/useFrontendMeta";
import PageMeta from "../PageMeta";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const UserLayout = ({ children }) => {
  const { pathname } = useLocation();
  const { data: headerData } = useFetchHeaderContentQuery();
  const meta = useFrontendMeta(pathname);
  const header = useMemo(() => ({
    products: (headerData?.header_products ?? []).map((p) => ({ name: p.name, slug: p.slug })),
    blogs: (headerData?.header_blogs ?? []).map((b) => ({ name: b.title, slug: b.slug })),
    brands: (headerData?.header_brands ?? []).map((b) => ({ name: b.name, slug: b.slug })),
    categories: (headerData?.header_categories ?? []).map((c) => ({
      name: c.name,
      slug: c.slug,
      sub_categories: (c.sub_categories ?? []).map((s) => ({ name: s.name, slug: s.slug })),
    })),
  }), [headerData]);
    console.log("Meta for path:", header, { meta });

  return (
    <div className="w-full h-full">
      <PageMeta
        title={meta?.title}
        description={meta?.description}
        keywords={meta?.keywords}
        og_tags={meta?.og_tags}
        canonical_links={meta?.canonical_links}
      />
      <Header {...header} contact={meta?.footer?.contact} />
      <div className="h-16 lg:h-25 mt-10" />
      <main>{children}</main>
      <Footer {...meta?.footer} siteMeta={meta} />
    </div>
  );
};
